module.exports = __webpack_public_path__ + "static/media/img-arrow-t2b--black.76b0d7c9.svg";